let navigateFnc;

export const setNavigate = fn => {
  navigateFnc = fn;
};

export const navigate = (to, options) => {
  if (navigateFnc) {
    navigateFnc(to, options);
  }
};
